export function atLeastNgDropdown() {

    return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModel) {

            const atLeast = modelValue => {

                if (modelValue == null) {

                    return true;
                }

                return modelValue.length >= 1;
            };

            scope.$watch(attrs.selectedModel, value => ngModel.$setValidity('atLeast', atLeast(value)), true);
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/at-least-ng-dropdown.js